<form (ngSubmit)="onSubmit.emit(this.form.value)" [formGroup]="form" class="form-horizontal">
  <div class="cashier-method__form">
    <ng-container *ngFor="let field of fields">
        <app-dynamic-field [field]="field" [form]="form" [ngClass]="field.isMultiRow && field.minWidth ? 'multi-input' : ''"></app-dynamic-field>
      <ng-container *ngIf="!field.isMultiRow || isSingleRow(field)">
        <app-custom-error-message style="display: none;" class="error-message--wrapper error-message-{{field.name}}" *ngIf="(form.controls[field.name].value || isSubmitted)" [message]="getErrorMessage(field.name,form)" [ngClass]="isSubmitted ? 'showField':''"></app-custom-error-message>
      </ng-container>
      <ng-container *ngIf="field.isMultiRow && !isSingleRow(field) && oneLineInputFields && oneLineInputFields.length && isEqualLastFieldName(field.name)">
        <ng-container *ngFor="let fieldName of oneLineInputFields">
          <ng-container *ngIf="(form.controls[fieldName].value || isSubmitted)">
           <div class="custom-errorWrap">
            <app-custom-error-message style="display: none;" class="error-message--wrapper error-message-{{fieldName}}" [message]="getErrorMessage(fieldName,form)" [ngClass]="isSubmitted ? 'showField':''"></app-custom-error-message>
           </div>
          </ng-container>
        </ng-container>
      </ng-container>        
    </ng-container>
    </div>
    <!-- <div class="form-row"></div> -->
  </form>